export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const RESET_NOTIFICATIONS = 'RESET_NOTIFICATIONS'

const initialState = {
  alerts: [],
  pushes: [],
}

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case ADD_NOTIFICATION: {
      const { notification, notificationType } = action

      if (!notificationType) return state

      if (notificationType === 'alert') {
        const alerts = [].concat(state.alerts)

        alerts.push(notification)

        return Object.assign({}, state, { alerts })
      } else if (notificationType === 'push') {
        const pushes = [].concat(state.pushes)

        pushes.push(notification)

        return Object.assign({}, state, { pushes })
      }

      return state
    }

    case REMOVE_NOTIFICATION: {
      const { id, notificationType } = action

      if (!notificationType) return state

      if (notificationType === 'alert') {
        const alerts = [].concat(state.alerts)
        const alertIndex = alerts.findIndex((a) => a.id === id)

        if (alertIndex >= 0) alerts.splice(alertIndex, 1)

        return Object.assign({}, state, { alerts })
      } else if (notificationType === 'push') {
        const pushes = [].concat(state.pushes)
        const pushIndex = pushes.findIndex((p) => p.id === id)

        if (pushIndex >= 0) pushes.splice(pushIndex, 1)

        return Object.assign({}, state, { pushes })
      }

      return state
    }

    case RESET_NOTIFICATIONS: {
      return initialState
    }

    default: {
      return state
    }
  }
}
